import React from 'react';
import './partner.scss';
import logo_1_1 from '../../assets/images/home/img_1_1.png';
import logo_1_2 from '../../assets/images/home/img_1_2.png';
import logo_1_3 from '../../assets/images/home/img_1_3.png';
import logo_2_1 from '../../assets/images/home/img_2_1.png';
import logo_2_2 from '../../assets/images/home/img_2_2.png';
import logo_2_3 from '../../assets/images/home/img_2_3.png';
import logo_2_4 from '../../assets/images/home/img_2_4.png';
import logo_3_1 from '../../assets/images/home/img_3_1.png';
import logo_3_2 from '../../assets/images/home/img_3_2.png';
import logo_3_3 from '../../assets/images/home/img_3_3.png';
import logo_3_4 from '../../assets/images/home/img_3_4.png';
import logo_4_1 from '../../assets/images/home/img_4_1.png';
import logo_4_2 from '../../assets/images/home/img_4_2.png';
// import logo_4_1 from '../../assets/images/home/ddd.png';
import logo_IP_1 from '../../assets/images/home/img_IP_1.png';
import logo_IP_2 from '../../assets/images/home/img_IP_2.png';
import logo_IP_3 from '../../assets/images/home/img_IP_3.png';
import logo_IP_4 from '../../assets/images/home/img_IP_4.png';
import logo_IP_5 from '../../assets/images/home/img_IP_5.png';
import logo_IP_6 from '../../assets/images/home/img_IP_6.png';
import logo_IP_7 from '../../assets/images/home/img_IP_7.png';
import logo_IP_8 from '../../assets/images/home/img_IP_8.png';


const OrganizationLogo = (props) => {
  const { logo, name } = props;
  return (
    <div className='org-logo'>
      <img src={logo} alt='' style={{ width: "65px", }} />
      <div style={Object.assign({ maxWidth: 135, fontSize: 14, lineHeight: '19px' }, props.style)}>
        {name}
      </div>
    </div>
  );
};
const Partner = () => {
  const strategicPartners = [
    {
      name: `中国科协生态环境产学联合体`,
      logo: logo_1_2,
      style: { maxWidth: 254, marginRight: 15 },
    },
    {
      name: '中国石油和化学工业联合会',
      logo: logo_1_3,
      style: { maxWidth: 254, marginRight: 15 },
    },
  ];
  const supportPartners = [
    { name: '中国环境科学学会', logo: logo_2_1 },
    { name: '中国循环经济协会', logo: logo_2_2 },
    { name: '中国包装联合会', logo: logo_2_3 },
    { name: '中国复合材料学会', logo: logo_2_4 },
    { name: '中国物资再生协会', logo: logo_3_1 },
    { name: '中国生态学会', logo: logo_3_2 },
    { name: '中国可再生能源学会', logo: logo_3_3 },
    {
      name: '生态环境部环境发展中心',
      logo: logo_3_4,
      style: { maxWidth: 254 },
    },
    {
      name: '中国塑料加工工业协会',
      logo: logo_4_1,
      style: { maxWidth: 254 },
    },
    {
      name: '中国制浆造纸研究院 ',
      logo: logo_4_2,
    },
  ];
  const IndustrialPartner = [
    { name: '绿色再生塑料供应链联合工作组', logo: logo_IP_7, style: { maxWidth: 254 }, },
    {
      name: '餐饮外卖绿色包装应用工作组', logo: logo_IP_8, style: { maxWidth: 254 },
    },
    { name: '德国国际合作机构', logo: logo_IP_1 },
    { name: 'Impact Hub Shanghai', logo: logo_IP_2, style: { maxWidth: 254 }, },
    { name: '璞跃中国 Plug and Play China ', logo: logo_IP_5, style: { maxWidth: 254 }, },
    { name: '金融支持绿色科技平台', logo: logo_IP_3, style: { maxWidth: 254 }, },
    { name: '中关村创蓝清洁空气产业联盟', logo: logo_IP_6, style: { maxWidth: 254 } },
    { name: '绿色创业汇 ', logo: logo_IP_4 },
  ];
  return (
    <div className='partner'>
      <div className='initiator-strategic'>
        <div className='initiator'>
          <div className='title'>
            <span>发起方</span>
            <div className='line'></div>
          </div>
          <img style={{ marginTop: '30px', width: 138, height: 65 }} src={logo_1_1} alt='' />
        </div>
        <div className='strategic'>
          <div className='title'>
            <span>战略合作伙伴</span>
            <div className='line'></div>
          </div>
          <div className='partners-content'>
            {strategicPartners.map((item) => {
              return (
                <OrganizationLogo
                  logo={item.logo}
                  name={item.name}
                  key={item.name}
                  style={item.style}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className='title support-title'>
        <span>联合支持单位</span>
        <div className='line'></div>
      </div>
      <div className='support-content'>
        {supportPartners.map((item) => {
          return (
            <OrganizationLogo
              logo={item.logo}
              name={item.name}
              key={item.name}
              style={item.style}
            />
          );
        })}
      </div>
      <div className='title support-title'>
        <span>产业合作伙伴</span>
        <div className='line'></div>
      </div>
      <div className='support-content'>
        {IndustrialPartner.map((item) => {
          return (
            <OrganizationLogo
              logo={item.logo}
              name={item.name}
              key={item.name}
              style={item.style}
            />
          );
        })}
      </div>
    </div>

  );
};

export default Partner;
